<template>
  <!-- 线型数据排行榜，只能固定的显示几个数据 -->
  <div class="worker-rank2">
    <yq-empty description="正在加载中" v-if="rankList.length === 0" style="padding: 0;opacity: .3"/>
    <div class="rank-item" v-for="(item, i) in rankList" :key="i">
      <div class="rank-no">
        <yq-icon name="zimuT"/>
        <yq-icon name="zimuO"/>
        <yq-icon name="zimuP"/>
        <yq-number :value="'0' + (i+1)"/>
      </div>
      <div class="rank-name">
        <div class="name">{{item.itemName}}</div>
        <div class="count">{{item.count}}{{unitName}}</div>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import YqNumber from "@/components/YqNumber.vue";
import YqIcon from "@/components/YqIcon.vue";

export default {
  props: {
    rankList: {default: () => [{itemName: "宜金高速", count: 15},{itemName: "江安一号工地", count: 10},{itemName: "新安二号工地", count: 5},{itemName: "新安三号工地", count: 3},{itemName: "乐资工地01", count: 2}]},
    unitName: {default: "次"}
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "RankList",
  components: {
    YqIcon,
    YqNumber
  },
  data() {
    return {
      rankColorList: ["#bdeef0","#63ffff","#3be3ff","#0091b7","#02495b"],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 找到最大值，计算比例
      if (!this.rankList.length) {
        return;
      }
      let max = this.rankList[0].count;
      for (let i = 0; i < this.rankList.length; i++) {
        if (this.rankList[i].count > max) {
          max = this.rankList[i].count;
        }
      }
      this.rankList.forEach(item => {
        item.percent = item.count / max * 100;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.worker-rank2{
  .rank-item{
    margin-bottom: 10px;
    font-size: 12px;
  }
  .rank-item{
    .rank-no{
      color: var(--map-color-text);
    }
  }
  .rank-item:first-child{
    .rank-no{
      font-size: 16px;
      //color: #FFF;
    }
  }
  .rank-item:last-child{
    margin-bottom: 0;
  }
  .rank-name{
    display: flex;
    justify-content: flex-start;
    .count{
      color: var(--map-color-text);
      margin-left: 10px;
      .baifenhao{
        font-size: 10px;
      }
    }
  }
}
</style>